import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/amortization-schedule-calculator',
  component: () => import('../../routes/AmortizationSchedule.svelte'),
  card: {
    id: 'amortization-schedule-calculator',
    title: 'Amortization Schedule',
    description: 'Generate a complete month-by-month loan amortization schedule with extra payment support and interest analysis.',
    icon: 'calendar_month',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/amortization-schedule-calculator',
    category: 'Loans & Debt',
  },
  seo: {
    title: 'Amortization Schedule Calculator – Month-by-Month Loan Payment Schedule',
    description: 'Free amortization schedule calculator. Generate a detailed month-by-month breakdown of your loan payments, principal, interest, and balance. Supports extra payments.',
  },
};

export default meta;